// Entrypoint de Vite (migrado de app/javascript/packs/application.js, webpacker).
// El <script> clásico en <head> provee jQuery (window.jQuery) para inline scripts
// durante el parse. El alias 'jquery' → shim en node_modules hace que TODOS los
// `import 'jquery'` y `require('jquery')` de plugins pre-bundeados (select2,
// bootstrap-table, slick, blockui) usen ESA MISMA instancia.
// No se sobrescribe window.$/window.jQuery: el clásico ya los dejó correctos.

import Rails from "@rails/ujs"
import { Turbo } from "@hotwired/turbo-rails"

// M8: definición ÚNICA de String.prototype.isEmpty, antes de cargar los controllers
import '../utils/string'

import $ from 'jquery'
import 'jquery-blockui'
import select2 from 'select2'

// select2 (v4.1) retorna la factory sin invocarla (patrón UMD
// `module.exports = function(root, jQuery)`). Debe ejecutarse una sola vez
// con la instancia ÚNICA de jQuery (window.jQuery del clásico en <head>).
select2(window, $)


import * as ActiveStorage from "@rails/activestorage"
import "../channels"

//Bootstrap
import 'bootstrap'
import 'bootstrap/js/dist/util'
import 'bootstrap/dist/css/bootstrap.css';
import "flatpickr/dist/flatpickr.css"
import "flatpickr/dist/themes/material_green.css"
import 'animate.css'
import 'popper.js'
import "@fortawesome/fontawesome-free/css/all.css"
import "font-awesome/scss/font-awesome.scss"
import '../css/icon-simpleline/scss/simple-line-icons.scss'
import 'slick-carousel/slick/slick.scss'
import 'slick-carousel/slick/slick-theme.scss'
import 'chartkick/highcharts'
import 'toastr/toastr.scss'
import MagicGrid from 'magic-grid'
import '../../assets/javascripts/serviceworker-companion.js';
window.MagicGrid = MagicGrid

Chartkick.configure({language: "es", mapsApiKey: "AIzaSyCJRQ7qfhPNlFrKRa9yPWUCv837ycrGESU"})


Rails.start()
Turbo.session.drive = false
Turbo.start()
ActiveStorage.start()

import "wowjs/css/libs/animate.css"
import "../controllers"
import 'trix'
import 'trix/dist/trix.css'
import '@rails/actiontext'

import I18n from 'i18n-js'
import '../i18n/translation'
window.I18n = I18n

// Legacy app_main scripts (previously bundled by Sprockets //=require)
// ScrollMagic is loaded as global <script> in head
import '../../assets/javascript/app_main/default/main'
import '../../assets/javascript/app_main/default/dropdown'

$(document).on('turbolinks:load',() => {

    let locale = $('body').data('locale');
    I18n.defaultLocale = locale
    I18n.locale = locale
})